import { type FC, type ReactNode } from "react";

import { Dropdown, PlacementTypes } from "@snapchat/snap-design-system";

import { type RemoteApiSpec } from "../../../gql-generated/types";

import { DropdownDeleteAction } from "./DropdownDeleteAction";
import { DropdownMenuContainer } from "./DropdownMenu.styles";

interface DropdownMenu {
    onDelete: (api: RemoteApiSpec) => Promise<void>;
    deleteLoading?: boolean;
    children?: ReactNode;
    api: RemoteApiSpec;
}

export const DropdownMenu: FC<DropdownMenu> = ({ onDelete, api, children, deleteLoading = false }) => {
    return (
        <Dropdown
            placement={PlacementTypes.BOTTOM_RIGHT}
            overlay={
                <DropdownMenuContainer>
                    <DropdownDeleteAction api={api} onDelete={onDelete} deleteLoading={deleteLoading} />
                </DropdownMenuContainer>
            }
        >
            {children}
        </Dropdown>
    );
};
